/* eslint-disable no-undef */
import get from 'lodash/get';
import has from 'lodash/has';
import { isEmpty } from 'lodash';
import find from 'lodash/find';
import AsyncLock from 'async-lock';
import { HomeTypes } from '../Types';
import HomeService from '../../services/API/HomeService';
import InputParser from '../../utils/InputParser';
import RoutingService from '../../services/RoutingService';
import { SETTINGS } from '../../constants/SettingsConstant';
import TelemetryService from '../../services/TelemetryService';
import TelemetryConstants from '../../constants/TelemetryConstants';
import { getJobDetails } from '../../services/API/JobsService';
import AuthService from '../../services/AuthService';
import * as FeedBackService from '../../services/API/FeedBackService';

const lock = new AsyncLock();

export default function homeActions(state, dispatch) {
  function fetchJobFeed(options = {}, cb) {
    const offset = has(options, 'offset') ? options.offset : state.offset;
    if (offset === null) {
      return;
    }

    dispatch({
      type: HomeTypes.IS_API_PROGRESS,
      payload: true,
    });

    HomeService.getJobsFeed({
      offset,
      city: (options && options.selectedCity) || state.selectedCity || {},
      minSalary: (options && options.minSalary) || state.selectedSalary,
      jobCategories: (options && options.selectedJobRoles) || state.selectedJobRoles,
      localities:
        (options && options.selectedLocalities) || state.selectedLocalities.map(item => item.id),
    })
      .then(data => {
        dispatch({
          type: HomeTypes.IS_API_PROGRESS,
          payload: false,
        });
        dispatch({
          type: HomeTypes.CONCAT_JOBS,
          payload: {
            jobs: get(data, 'jobs', []),
            offset: get(data, 'offset', 0),
          },
        });
        cb && cb();
      })
      .catch(error => {
        console.log('Job feed fetch -> error', error);
        dispatch({
          type: HomeTypes.IS_API_PROGRESS,
          payload: false,
        });
        cb && cb();
      });
  }

  function setSelectedJob() {
    dispatch({
      type: HomeTypes.UNSET_SELECTED_JOB,
    });

    if (InputParser.getJobID()) {
      const isAuthenticated = Boolean(AuthService.getUserID());
      if (!find(state.jobs, { jobCityWorkLocationId: InputParser.getJobID() })) {
        getJobDetails(
          InputParser.getJobID(),
          InputParser.getJobCityWorkLocationID(),
          isAuthenticated
        ).then(data => {
          dispatch({
            type: HomeTypes.SET_SELECTED_JOB,
            payload: { selectedJob: data },
          });
        });
      } else {
        dispatch({
          type: HomeTypes.SET_SELECTED_JOB,
          payload: {
            selectedJob: find(state.jobs, { jobCityWorkLocationId: InputParser.getJobID() }),
          },
        });
      }
    }
  }

  function fetchJobApplications() {
    dispatch({
      type: HomeTypes.IS_JOB_APPLICATION_API_IN_PROGRESS,
      payload: true,
    });

    dispatch({
      type: HomeTypes.SET_JOB_APPLICATIONS,
      payload: [],
    });

    HomeService.getJobsApplicationFeed()
      .then(data => {
        dispatch({
          type: HomeTypes.IS_JOB_APPLICATION_API_IN_PROGRESS,
          payload: false,
        });
        dispatch({
          type: HomeTypes.SET_JOB_APPLICATIONS,
          payload: data.applications || [],
        });

        data.applications.forEach(async application => {
          const jobDetails = await getJobDetails(application.jobId);
          dispatch({
            type: HomeTypes.CONCAT_JOBS,
            payload: {
              jobs: [jobDetails],
              offset: state.offset,
            },
          });
        });
      })
      .catch(error => {
        console.log('Job feed fetch -> error', error);
        dispatch({
          type: HomeTypes.IS_JOB_APPLICATION_API_IN_PROGRESS,
          payload: false,
        });
      });
  }

  async function applySelectedJob(isNew = false) {
    if (!get(state, 'selectedJob.id')) {
      return;
    }
    dispatch({
      type: HomeTypes.IS_API_PROGRESS,
      payload: true,
    });

    lock.acquire(
      1,
      done => {
        HomeService.applyJob({
          jobId: state.selectedJob.jobId,
          scheduledAt: new Date().toISOString(),
          // jobCityWorkLocationId: state.selectedJob.jobCityWorkLocationId,
        })
          .then(() => {
            dispatch({
              type: HomeTypes.IS_API_PROGRESS,
              payload: false,
            });
            dispatch({
              type: HomeTypes.JOB_APPLY_IN_PROGRESS,
              payload: false,
            });
            // lock.disable();
            const { jobApplications } = state;
            /**
             * Sending Metrics if new user
             */
            const isNewUser = isEmpty(jobApplications) || isNew;
            if (isNewUser) {
              TelemetryService.sendEvent(
                [
                  TelemetryConstants.JOB_APP,
                  TelemetryConstants.NAME_AGE_GENDER,
                  TelemetryConstants.FIRST_TIME_JOB_APP,
                ],
                {
                  jobId: state.selectedJob.jobId,
                }
              );
            }
            RoutingService.gotoApplicationSuccess();
            done();
          })
          .catch(error => {
            console.log('Job feed fetch -> error=', error);
            dispatch({
              type: HomeTypes.IS_API_PROGRESS,
              payload: false,
            });
            dispatch({
              type: HomeTypes.JOB_APPLY_IN_PROGRESS,
              payload: false,
            });
            done();
          });
      },
      (err, ret) => {
        console.log('Freeing lock ', ret);
      }
    );
  }

  function openSalaryRange() {
    dispatch({
      type: HomeTypes.TOGGLE_SALARY_RANGE,
      payload: true,
    });
  }

  function closeSalaryRange() {
    dispatch({
      type: HomeTypes.TOGGLE_SALARY_RANGE,
      payload: false,
    });
  }

  function resetPage() {
    dispatch({
      type: HomeTypes.RESET_FEED,
    });
  }

  function setSalary(salary) {
    dispatch({
      type: HomeTypes.SALARY_SELECTED,
      payload: salary,
    });
  }

  function onSalarySelected(salary) {
    resetPage();
    setSalary(salary);
    setTimeout(() => {
      fetchJobFeed({ minSalary: salary, offset: 0 }, closeSalaryRange);
    }, 200);
  }

  function openCitySelection() {
    dispatch({
      type: HomeTypes.TOGGLE_CITY,
      payload: true,
    });
  }
  function closeCitySelection() {
    dispatch({
      type: HomeTypes.TOGGLE_CITY,
      payload: false,
    });
  }

  function setCity(city) {
    dispatch({
      type: HomeTypes.CITY_SELECTED,
      payload: city,
    });
  }

  function onCitySelected(city) {
    resetPage();
    setCity(city);
    setTimeout(() => {
      fetchJobFeed({ selectedCity: city, offset: 0 }, closeCitySelection);
    }, 500);
  }

  function openJobRoleSelection() {
    dispatch({
      type: HomeTypes.TOGGLE_JOB_ROLE,
      payload: true,
    });
  }
  function closeJobRoleSelection() {
    dispatch({
      type: HomeTypes.TOGGLE_JOB_ROLE,
      payload: false,
    });
  }

  function setJobRoles(selectedJobRoles) {
    dispatch({
      type: HomeTypes.ROLES_SELECTED,
      payload: selectedJobRoles,
    });
  }

  function onJobRolesSelected(selectedJobRoles) {
    resetPage();
    setJobRoles(selectedJobRoles);
    setTimeout(() => {
      fetchJobFeed({ selectedJobRoles, offset: 0 }, closeJobRoleSelection);
    }, 500);
  }

  function onSelectJobApplication(applicationId) {
    if (!isEmpty(applicationId)) {
      dispatch({
        type: HomeTypes.SELECT_JOB_APPLICATION,
        payload: applicationId,
      });
    }
  }

  function onCloseJobTracker() {
    dispatch({
      type: HomeTypes.SELECT_JOB_APPLICATION,
      payload: '',
    });
  }

  function fetchTrackingInfo(jobApplicationId) {
    dispatch({
      type: HomeTypes.SET_TRACK_INFO,
      payload: [],
    });

    dispatch({
      type: HomeTypes.IS_API_PROGRESS,
      payload: true,
    });

    if (jobApplicationId) {
      HomeService.getJobApplicationTracking({
        jobApplicationId,
      })
        .then(data => {
          dispatch({
            type: HomeTypes.IS_API_PROGRESS,
            payload: false,
          });
          dispatch({
            type: HomeTypes.SET_TRACK_INFO,
            payload: data.statusHistory,
          });
        })
        .catch(error => {
          console.log('Job feed fetch -> error', error);
          dispatch({
            type: HomeTypes.IS_API_PROGRESS,
            payload: false,
          });
        });
    }
  }
  function openLocalitySelection() {
    dispatch({
      type: HomeTypes.TOGGLE_LOCALITY,
      payload: true,
    });
  }
  function closeLocalitySelection() {
    dispatch({
      type: HomeTypes.TOGGLE_LOCALITY,
      payload: false,
    });
  }

  function onSelectLocality(localities) {
    resetPage();
    dispatch({
      type: HomeTypes.LOCALITY_SELECTED,
      payload: localities,
    });
    setTimeout(() => {
      fetchJobFeed(
        { selectedLocalities: localities.map(item => item.id), offset: 0 },
        closeLocalitySelection
      );
    }, 500);
  }

  function getUserSettings() {
    dispatch({
      type: HomeTypes.LOADING_USER_SETTING,
      payload: true,
    });
    HomeService.getUserSettings()
      .then(res => {
        dispatch({
          type: HomeTypes.SET_USER_SETTINGS,
          payload: res,
        });
      })
      .catch(err => {
        console.log('Failed to get user settings::', err);
      })
      .finally(() => {
        dispatch({
          type: HomeTypes.LOADING_USER_SETTING,
          payload: false,
        });
      });
  }
  function updateUserSettings(settings) {
    dispatch({
      type: HomeTypes.LOADING_USER_SETTING,
      payload: true,
    });
    HomeService.updateUserSettings(settings)
      .then(res => {
        dispatch({
          type: HomeTypes.SET_USER_SETTINGS,
          payload: res,
        });
      })
      .catch(err => {
        console.log('Failed to get user settings::', err);
      })
      .finally(() => {
        dispatch({
          type: HomeTypes.LOADING_USER_SETTING,
          payload: false,
        });
      });
  }

  function updateWhatsAppNotify() {
    const { userSettings } = state;
    const updatedSettings = { ...userSettings, whatsAppOptIn: !userSettings.whatsAppOptIn };
    updateUserSettings(updatedSettings);
  }

  function updateNotification() {
    if (!Notification) {
      alert('Desktop notifications not available in your browser. Try Chromium.');
      return;
    }
    const { userSettings } = state;
    if (userSettings.notifications) {
      if (Notification.permission !== 'granted') {
        const updatedSettings = { ...userSettings, notifications: false };
        dispatch({
          type: HomeTypes.SET_USER_SETTINGS,
          payload: updatedSettings,
        });
        updateUserSettings(updatedSettings);
      }
      return;
    }

    if (Notification.permission === 'denied') {
      alert('Please Enable Notification from settings');
    } else if (Notification.permission === 'granted') {
      const updatedSettings = { ...userSettings, notifications: true };
      dispatch({
        type: HomeTypes.SET_USER_SETTINGS,
        payload: updatedSettings,
      });
      updateUserSettings(updatedSettings);
    } else if (Notification.permission !== 'granted') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          const updatedSettings = { ...userSettings, notifications: true };
          dispatch({
            type: HomeTypes.SET_USER_SETTINGS,
            payload: updatedSettings,
          });
          updateUserSettings(updatedSettings);
        }
      });
    }
  }

  function updateInstallation() {
    const { userSettings } = state;
    if (window.deferredPrompt) {
      // Show the prompt
      window.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      window.deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
          const updatedSettings = { ...userSettings, addToHomeScreen: true };
          updateUserSettings(updatedSettings);
          return;
        }
        const updatedSettings = { ...userSettings, addToHomeScreen: false };
        updateUserSettings(updatedSettings);
        window.deferredPrompt = null;
      });
    }
  }

  function onSettingAction(type) {
    switch (type) {
      case SETTINGS.WHATSAPP:
        updateWhatsAppNotify();
        break;
      case SETTINGS.NOTIFICATION:
        updateNotification();
        break;
      case SETTINGS.INSTALL:
        updateInstallation();
        break;
      default:
    }
  }
  function openWorkArea() {
    dispatch({
      type: HomeTypes.TOGGLE_WORK_AREA,
      payload: true,
    });
  }
  function closeWorkArea() {
    dispatch({
      type: HomeTypes.TOGGLE_WORK_AREA,
      payload: false,
    });
  }
  function openBottomLogin() {
    dispatch({
      type: HomeTypes.TOGGLE_LOGIN,
      payload: true,
    });
  }
  function closeBottomLogin() {
    dispatch({
      type: HomeTypes.TOGGLE_LOGIN,
      payload: false,
    });
  }

  function openBottomOTP() {
    dispatch({
      type: HomeTypes.TOGGLE_OTP,
      payload: true,
    });
  }
  function closeBottomOtp() {
    dispatch({
      type: HomeTypes.TOGGLE_OTP,
      payload: false,
    });
  }

  function onApplyJob(userProfile, isNew = false) {
    const { name, gender } = userProfile;
    // collect Name and Age if new User
    if (isEmpty(name) || isEmpty(gender)) {
      RoutingService.gotoUserDetailsEntry({
        search: `?jobID=${InputParser.getJobID()}&jobCityWorkLocationID=${InputParser.getJobCityWorkLocationID()}`,
      });
      return;
    }
    applySelectedJob(isNew);
  }

  function onClickApplyJob(userProfile) {
    console.log('userProfile: ', userProfile);
    const { selectedJob } = state;
    const { mobile, name, gender } = userProfile;
    console.log('mobile: ', mobile);
    if (isEmpty(mobile)) {
      openBottomLogin();
      return;
    }
    if (isEmpty(name) || isEmpty(gender)) {
      RoutingService.gotoUserDetailsEntry({
        search: `?jobID=${InputParser.getJobID()}&jobCityWorkLocationID=${InputParser.getJobCityWorkLocationID()}`,
      });
      return;
    }
    // if (!isEmpty(get(selectedJob, 'requirements.documents', []))) {
    //   RoutingService.gotoApplyJobDoc({
    //     search: `?jobID=${InputParser.getJobID()}&jobCityWorkLocationID=${InputParser.getJobCityWorkLocationID()}`,
    //   });
    // }
    else {
      onApplyJob(userProfile);
    }
  }

  function setCallMitraFlowState(callMitraFlowState) {
    dispatch({
      type: HomeTypes.SET_MITRA_CALL_FLOW_STATE,
      payload: callMitraFlowState,
    });
  }

  function setCallingThroughApplyFlow(callingThroughApplyFlow) {
    dispatch({
      type: HomeTypes.SET_CALLING_THROUGH_APPLY_FLOW,
      payload: callingThroughApplyFlow,
    });
  }

  function setSelectedJobForCall(selectedJobId) {
    const selectedJobForCall = state.jobs.find(job => {
      return job.jobId === selectedJobId;
    });

    dispatch({
      type: HomeTypes.SET_SELECTED_JOB_FOR_CALL,
      payload: selectedJobForCall,
    });
  }

  function createUserJobCall(options, callback) {
    if (AuthService.getUserMobile()) {
      HomeService.createUserJobCall({
        calleeNumber: options.telecallerNumber,
        callerNumber: AuthService.getUserMobile(),
        userId: AuthService.getUserID(),
        jobId: options.jobId,
        source: 'Pwa',
      }).then(res => {
        window.open(`tel:${state.kookooBridgeNumber}`);
        callback(res);
      });
    } else {
      window.open(`tel:${options.telecallerNumber}`);
      callback();
    }
  }

  function submitJobNotWantedFeedback(options, callback) {
    dispatch({
      type: HomeTypes.IS_API_PROGRESS,
      payload: true,
    });
    FeedBackService.submitFeedback({
      types: ['DO_NOT_WANT_JOB_REASON'],
      comment: options.feedback,
      jobId: options.jobId,
    })
      .then(() => {
        callback && callback();
      })
      .catch(error => {
        console.log('Error in job not wanted feedback submission==>', error);
      })
      .finally(() => {
        dispatch({
          type: HomeTypes.IS_API_PROGRESS,
          payload: false,
        });
      });
  }

  return {
    fetchJobApplications,
    fetchJobFeed,
    setSelectedJob,
    applySelectedJob,
    openSalaryRange,
    closeSalaryRange,
    onSalarySelected,
    openCitySelection,
    closeCitySelection,
    onCitySelected,
    openJobRoleSelection,
    closeJobRoleSelection,
    onJobRolesSelected,
    onSelectJobApplication,
    onCloseJobTracker,
    fetchTrackingInfo,
    openLocalitySelection,
    closeLocalitySelection,
    onSelectLocality,
    getUserSettings,
    onSettingAction,
    openWorkArea,
    closeWorkArea,
    onClickApplyJob,
    onApplyJob,
    openBottomLogin,
    closeBottomLogin,
    openBottomOTP,
    closeBottomOtp,
    setCallMitraFlowState,
    setCallingThroughApplyFlow,
    createUserJobCall,
    submitJobNotWantedFeedback,
    setCity,
    setJobRoles,
    setSalary,
    setSelectedJobForCall,
  };
}
